import AppRegion from './app-region';
import AppMode from './app-mode';
import AppRequirement from './app-requirement';
import Locale from './locale';
import LocalCurrency from './local-currency';
import LocalizedString from './localized-string';
import MessageSet from './message-set';
import { DATA_PROVIDER } from '@/utils/users';
import { COMPARISON_CATEGORIES } from '@/utils/constants';

export enum SETTINGS_FORM_INPUT_STATE {
  DISABLED = 'disabled',
}

type AppConfig = {
  requirements: Array<AppRequirement>;
  mode: AppMode;
  whitelabel?: MessageSet;
  appLocales: Locale[];
  appRegion: AppRegion;
  localCurrency: LocalCurrency;
  search?: {
    FUNDS?: {
      data_providers: DATA_PROVIDER[];
    };
  };
  postMessages: {
    active: boolean;
    targetOrigin: string;
    sourceOrigins: [string];
    actionsToListen: string[];
  };
  linkBranding?: {
    image?: {
      sm?: LocalizedString;
      lg?: LocalizedString;
    };
    url?: LocalizedString;
  };
  persistenceKeys?: Array<string>;
  dataSourceTabs?: {
    contacts?: DataSourceTabs[];
    portfolios?: DataSourceTabs[];
  };
  settings?: {
    userForm?: {
      fname?: SETTINGS_FORM_INPUT_STATE;
      lname?: SETTINGS_FORM_INPUT_STATE;
    };
  };
  preferredDataProviders: PreferredDataProvider[];
  customProxyMapping: CustomProxyMapping[];
  comparison?: {
    hiddenCategories?: COMPARISON_CATEGORIES[];
    hideAddCategoryBenchmark?: boolean;
    accountSetRecommendations?: {
      labels?: LocalizedString[];
    };
  };
  proposal?: {
    excludedTopFundsSymbols?: string[];
  };
};

export type DataSourceTabs = {
  isPostMessage?: boolean;
  label: LocalizedString;
  persistenceKey?: string;
  value: string;
};

export type PreferredDataProvider = {
  instrumentType: string;
  key: string;
  provider: DATA_PROVIDER;
};

export type CustomProxyMapping = {
  id: string;
  proxyRef: string;
  type: string;
};

export default AppConfig;
